import { UIEvent } from 'react';

export enum EMPTY_CART_CONST {
  TEST_ID = 'empty-cart',
}

export interface EmptyCartProps {
  onClick: (event: UIEvent<HTMLButtonElement>) => void;
}
